'use client';

import React from 'react';
import { ApolloProvider } from '@apollo/client';
import client from '@/lib/apollo-client-simple';
import { CartProvider } from '@/contexts/CartContext';
import { WishlistProvider } from '@/contexts/WishlistContext';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ApolloProvider client={client}>
      <CartProvider>
        <WishlistProvider>
          {children}
        </WishlistProvider>
      </CartProvider>
    </ApolloProvider>
  );
}
